import { ReactElement } from 'react'
import { useParams } from 'react-router'
import { Outlet } from 'react-router-dom'
import { Route } from 'src/routing/routing'
import { resolveApplicationDetailsRoot } from 'src/routing/routing-utils'
import { SecondLevelNavigation, SecondLevelNavigationContainer } from 'src/routing/SecondLevelNavigation'
import { usePermissionsForProjectApplication } from 'src/service/security/PermissionHook'
import { PageLayout } from 'src/shared/layout/PageLayout'
import { NotAuthorized } from 'src/shared/not-authorized/NotAuthorized'
import { useActiveRoute } from 'src/shared/utils/hooks/route-hooks'
import { Utils } from 'src/shared/utils/Utils'

interface Props {
  baseUrl: '/pf-kap' | '/pf-pgv'
}

export const ApplicationDetailsIndex = ({ baseUrl }: Props): ReactElement => {
  const { projectId } = useParams()
  const process = Utils.resolveProcess(baseUrl)
  const { loading, canView } = usePermissionsForProjectApplication(process, parseInt(projectId as string))
  const activeRoute = useActiveRoute(baseUrl, resolveApplicationDetailsRoot(baseUrl) as unknown as Route, projectId)

  const showNavigation = activeRoute && !activeRoute.hideNavigation

  if (!loading && !canView) {
    return <NotAuthorized />
  }

  return (
    <>
      {!loading && (
        <SecondLevelNavigationContainer $showNavigation={showNavigation}>
          {showNavigation && (
            <PageLayout>
              <SecondLevelNavigation
                activeRoute={activeRoute}
                route={resolveApplicationDetailsRoot(baseUrl) as unknown as Route}
                baseUrl={resolveApplicationDetailsRoot(baseUrl).params({ projectId })}
              />
            </PageLayout>
          )}
          <Outlet />
        </SecondLevelNavigationContainer>
      )}
    </>
  )
}
